export default __webpack_public_path__ + "static/media/AsesorPedagogico.ec1f2c5e.png";